import React from 'react';
import { usePortalLanguage } from '../../../contexts/PortalLanguageContext';

const initialsFromName = (name = '') => {
    const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Gold ring (D-39): this component only renders on the dark-green agent card.
function AgentHeadshot({ url = '', name = '', size = 96 }) {
    const { t } = usePortalLanguage();
    if (url) {
        return (
            <img
                src={url}
                alt={name || t('Agent headshot')}
                className="rounded-full object-cover ring-2 ring-[color:var(--color-accent)] ring-offset-2 ring-offset-[color:var(--color-primary)]"
                style={{ width: size, height: size }}
            />
        );
    }
    return (
        <div
            className="rounded-full bg-[color:var(--sidebar-item-active)] text-[color:var(--sidebar-text-color)] font-semibold flex items-center justify-center ring-2 ring-[color:var(--color-accent)] ring-offset-2 ring-offset-[color:var(--color-primary)]"
            style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
        >
            {initialsFromName(name)}
        </div>
    );
}

export default AgentHeadshot;
